// saasShared.jsx — 테넌트 관리 공유 스타일·헬퍼 (SaasTenantManagement / CompaniesTab 공용)
import React from 'react';
import { stdBlackBtn, stdOutlineBtn } from '../adminlayout/designStandard';

export const input = { padding: '7px 10px', border: '1px solid var(--border)', borderRadius: 7, fontSize: 13, background: 'var(--bg-card)', color: 'var(--text)' };
// 디자인 표준(2026-08 통일): 주요=검정 박스 / 보조=흰 외곽선
export const btn = { ...stdBlackBtn };
export const btnOutline = { ...stdOutlineBtn };
export const card = { border: '1px solid var(--border)', borderRadius: 8, background: 'var(--bg-card)', padding: 14 };
export const th = { textAlign: 'left', padding: '8px 10px', fontSize: 12, color: 'var(--text-muted)', borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap' };
export const td = { padding: '8px 10px', fontSize: 13, color: 'var(--text)', borderBottom: '1px solid var(--bg-subtle)' };

// 상태 글자(2026-10-25 요금제 4-1): 테넌트·회사 = 사용/비활성, 구독 = 체험/사용/정지/해지
export const STATUS_LABELS = { active: '사용', trial: '체험', suspended: '정지', canceled: '해지', inactive: '비활성', shadow: '숨김' };

export function statusBadge(s) {
  const map = { active: '#16a34a', trial: '#2563eb', suspended: '#d97706', canceled: '#dc2626', inactive: '#6b7280' };
  const c = map[s] || 'var(--text-muted)';
  return <span style={{ fontSize: 11, fontWeight: 800, color: c, border: `1px solid ${c}`, borderRadius: 5, padding: '1px 7px' }}>{STATUS_LABELS[s] || s || '-'}</span>;
}

export function TenantPicker({ tenants, selected, setSelected }) {
  return (
    <select style={{ ...input, minWidth: 200 }} value={selected} onChange={(e) => setSelected(e.target.value)}>
      {tenants.map((t) => <option key={t.code} value={t.code}>{t.name} ({t.code})</option>)}
    </select>
  );
}
